import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
// 数据源
import { ListStore } from '../../store';
// 素材
import player from '@src/mobile/details/layout/assets/player.png';
// 组件
import LoadingMore from '@src/components/LoadingMore'; // 加载更多
// 接口
import { getRecommend } from '../../services';
// 拉端
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { setAppQuery, setAppQueryNoIfengsp, setQuery } from '@src/utils/url';
import Observer from '@researchgate/react-intersection-observer';
import { pageStatistics } from '@ifeng-fe/mobile_statistics';
import { devPath, LINK_URL } from '@src/constants';
import { formatUrl, formatImage } from '@ifeng-fe/public_method';
import { WxLaunchApp } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchApp/dynamic';

// 新版Grounds
import { Grounds } from '@ifeng-fe/client_grounds';

const Recommend = ({ content }) => {
    const {
        params: { id },
    } = content;

    // 列表数据源
    const useListStore = ListStore.useContainer();
    const { listStates, changeListStates } = useListStore;
    const {
        dramaSeries,
        recommond, // 更多推荐
        page, // 页码
    } = listStates;
    // page
    const sendPage = (
        videoId, // 目标剧集id
        dramaSeriesId, // 当前页面剧集id
        index, // 从0开始
        reftype, // 接口返回
    ) => {
        pageStatistics({
            behavior: 'page',
            id: `phmovie_${videoId}`,
            type: 'phmovie',
            ref: `phmovie_${dramaSeriesId}`,
            reftype,
            rnum: `7_${index}`,
            showtype: 'morerec',
            pagetag: '', // 手动clear
        });
    };

    // 曝光
    const handleObserverChange = (entry, unobserve, index) => {
        const { isIntersecting } = entry;

        if (isIntersecting) {
            const { id, reftype } = recommond[index];

            const recommondId = id.split('_')[1];

            Grounds.expose({
                id: `phmovie_${recommondId}`, // 曝光id必须唯一，不能为固定值
                rnum: `7_${index}`,
                // reftype, // 不加encodeURL
                ch: `phmovie_${dramaSeries.base62Id}`, // 原ref
                src: '',
                showtype: 'morerec',
                pagetype: 'phmovie',
            });

            unobserve();
        }
    };

    // 点击更多推荐
    const handlerRecommond = (item, index, isJumpQQlink = false, isCallAppWx = true) => {
        const { id } = item;

        const base62Id = id?.split('_')[1] ? id.split('_')[1] : id;
        const url = `${LINK_URL}/details/${base62Id}`;
        // const url = `${window.location.origin}/mobile/phtv/loc/tvTheater/details/${base62Id}`;
        // 发送统计

        sendPage(base62Id, dramaSeries.base62Id, index, item.reftype);

        if (window.grounds) {
            const option = {
                link: {
                    type: 'web',
                    url: `${setAppQuery(url)}&needpage=1`,
                },
                pageLogParams: {
                    ref: `phmovie_${dramaSeries.base62Id}`,
                },
            };

            Grounds.dispatch(option);
        } else {

            const finalUrl = setAppQueryNoIfengsp(
                `${devPath}/details/${id}?id=phmovie&ref=outside&type=other&backIndex=true`,
            );

            if (isCallAppWx) {
                callApp({
                    docType: 'web',
                    pid: finalUrl,
                    kind: 'inter_da01',
                    noKindFrom: 1,
                    download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1512057577113',
                    downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8927',
                    isJumpQQlink
                });
            }
        }
    };

    // 加载下一页（必须使用async/await 返回异步数据，不然加载时机会出错)
    const loadMoreData = async () => {
        try {
            const {
                data: { items },
            } = await getRecommend({ page, docId: dramaSeries.base62Id });

            changeListStates({
                recommond: [...recommond, ...items],
                page: page + 1,
            });

            return 'success';
        } catch (error) {
            console.log(error);

            return 'error';
        }
    };

    const SchemeLink = (item) => {
        const { id } = item;
        const finalUrl = setAppQueryNoIfengsp(
            `${devPath}/details/${id}?id=phmovie&ref=outside&type=other&backIndex=true`,
        );

        return getSchemeLink({
            docType: 'web',
            pid: finalUrl,
            kind: 'inter_da01',
            noKindFrom: 1
        });
    };

    return (
        <>
            {//  端内
            window.grounds ? (
                <div className={styles.wrap}>
                    {recommond && recommond.length ? <div className={styles.title}>更多推荐</div> : null}
                    <div className={styles.listWrap}>
                        {recommond && recommond.length
                            ? recommond.map((item, index) => {
                                  const { thumbnail, title, subhead, playTimeStr, numText } = item;

                                  return (
                                      <Observer
                                          onChange={(entry, unobserve) => handleObserverChange(entry, unobserve, index)}
                                          key={index}>
                                          <div className={styles.itemsWrap} onClick={() => handlerRecommond(item, index)}>
                                              <div className={styles.itemImgWrap}>
                                                  {numText ? (
                                                      <>
                                                          <div className={styles.mask} />
                                                          <div className={styles.itemNumText}>{numText}</div>
                                                      </>
                                                  ) : null}

                                                  <img
                                                      className={styles.itemsImg}
                                                      //    src={thumbnail}
                                                      src={formatImage(thumbnail, 264, 149)}
                                                  />
                                              </div>

                                              <div className={styles.itemsContent}>
                                                  <div className={styles.itemsTitle}>{title}</div>
                                                  <div className={styles.itemSubhead}>{subhead}</div>
                                                  <div className={styles.itemPlay}>
                                                      <img className={styles.itemPlayimg} src={player} />
                                                      <div className={styles.itemPlayTimeStr}>
                                                          {playTimeStr ? playTimeStr : 0}
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </Observer>
                                  );
                              })
                            : null}
                    </div>

                    {/* 加载更多 */}
                    {recommond && recommond.length ? <LoadingMore control={loadMoreData} /> : null}
                </div>
            ) : (
                //  端外
                <div className={styles.wrap}>
                    {recommond && recommond.length ? <div className={styles.title}>更多推荐</div> : null}
                    <div className={styles.listWrap}>
                        {recommond && recommond.length
                            ? recommond.slice(0, 3).map((item, index) => {
                                  const { thumbnail, title, subhead, playTimeStr, numText } = item;

                                  return (
                                      <Observer
                                          onChange={(entry, unobserve) => handleObserverChange(entry, unobserve, index)}
                                          key={index}>
                                          <div
                                              className={styles.itemsWrap}
                                              key={index}
                                              onClick={() => handlerRecommond(item)}>
                                              <div className={styles.itemImgWrap}>
                                                  {numText ? (
                                                      <>
                                                          <div className={styles.mask} />
                                                          <div className={styles.itemNumText}>{numText}</div>
                                                      </>
                                                  ) : null}

                                                  {/* <div className={styles.groundsTitle}>APP内播放</div> */}

                                                  <img
                                                      className={styles.itemsImg}
                                                      //   src={formatUrl(thumbnail)}
                                                      src={formatImage(thumbnail, 264, 149)}
                                                  />
                                              </div>

                                              <div className={styles.itemsContent}>
                                                  <div className={styles.itemsTitle}>{title}</div>
                                                  <div className={styles.itemSubhead}>{subhead}</div>

                                                  <div className={styles.itemShareText}>APP内打开</div>
                                              </div>
                                              <WxLaunchApp
                                                  launchType="app"
                                                  launchAppClick={() => handlerRecommond(item, index, false, false)}
                                                  schemeLink={SchemeLink(item)}
                                                  launchAppFail={() => handlerRecommond(item, index, true, true)}
                                              />
                                          </div>
                                      </Observer>
                                  );
                              })
                            : null}
                    </div>
                </div>
            )}
        </>
    );
};

Recommend.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Recommend);
